interface AuthConfirmationProps {
  className?: string;
}

export function AuthConfirmation({ className = '' }: AuthConfirmationProps) {
  
  return (
    <div className={`text-center space-y-6 ${className}`}>
      {/* 로딩 스피너 */}
      <div className="flex justify-center mb-8">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-200 border-t-green-500"></div>
      </div>

      {/* 메인 메시지 */}
      <div className="space-y-4">
        <h1 className="text-[28px] font-bold text-[#222222]">
          이메일 인증 중...
        </h1>
        <p className="text-[16px] text-gray-600 leading-relaxed">
          이메일 인증을 처리하고 있습니다<br />
          잠시만 기다려주세요
        </p>
      </div>

      {/* 진행 상태 표시 */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 max-w-md mx-auto">
        <div className="flex items-center space-x-3">
          <div className="w-4 h-4 bg-blue-500 rounded-full animate-pulse"></div>
          <p className="text-[14px] text-blue-700 font-medium">
            인증 링크 확인 중
          </p>
        </div>
      </div>

      {/* 추가 안내 */}
      <div className="text-center text-[12px] text-gray-500 max-w-sm mx-auto">
        인증이 완료되면 자동으로 로그인 페이지로 이동합니다
      </div>
    </div>
  );
}